export default {
    'pages.branch.Add Branch': 'Shto një degë',
    'pages.branch.Branch Card': 'Karta e degës',
    'pages.branch.Branch': 'Dega',
    'pages.branch.Re-assign Branch': 'Ricaktimi i degës',
    'pages.branch.Transfer Sales': 'Transferimi i shitjeve',
    'pages.branch.Policies': 'Policat',
    'pages.branch.Branch Policies': 'Policat e degës',
    'pages.branch.Agencies': 'Agjencitë',
    'pages.agencies.Agency Card': 'Karta e agjencisë',
    'pages.agencies.General': 'Gjeneral',
    'pages.agencies.Agency': 'Agjencia',
    'pages.agencies.Agents': 'Agjentët',
    'pages.agencies.Policies': 'Policat',
    'pages.agencies.Agency Policies': 'Policat e Agjencisë',
    'pages.agencies.Documents': 'Dokumentet',
    'pages.agencies.Add Agency': 'Shto agjenci',
    'pages.agencies.Other': 'Tjetër',
    'pages.customers.Add Customer': 'Shto klient',
    'pages.customers.Customer': 'Klient',
    'pages.customers.Info': 'Info',
    'pages.customers.Policies': 'Policat',
    'pages.customers.Customer Policies': 'Policat e klientit',
    'pages.hospitals.Add Hospital': 'Shto spital',
    'pages.hospitals.Hospital': 'Spitali',
    'pages.insurers.Add Insurer': 'Shto siguruesin',
    'pages.insurers.Insurer': 'Siguruesi',
    'pages.intermediaries.Add Intermediary': 'Shto ndërmjetës',
    'pages.intermediaries.Intermediary': 'Ndërmjetës',
    'pages.underwriters.Add Underwriter': 'Shto Nënshkrues',
    'pages.underwriters.Underwriter': 'Nënshkrues',
    'pages.finance.TableOfEntries': 'Tabela e zerave',
    'pages.finance.delete Entries': 'Fshi zerin',
    'page.finance.total amount': 'Vlera totale',
    'page.finance.selectedInvoices': 'Faturat e selektuara:',
    'page.finance.searchAgency': 'Kerko agjencinë',
};
